import * as React from 'react';

import styles from './inline-tabs.module.css';

export type Props = {
    name: string;
    selectedTab: string;
    onChange: (newValue: any) => void;
    isDark?: boolean;
    tabMinWidth?: number;
    children: React.ReactNode;
};

export const InlineTabsContext = React.createContext('inlineTabs');

export class InlineTabs extends React.Component<Props> {
    render() {
        const {name, onChange, selectedTab, isDark, tabMinWidth} = this.props;

        return (
            // @ts-expect-error
            <InlineTabsContext.Provider value={{name, onChange, selectedTab, isDark, tabMinWidth}}>
                <div role='tablist' className={styles['inline-tabs']}>
                    {this.props.children}
                </div>
            </InlineTabsContext.Provider>
        );
    }
}
